import React from 'react';
import { Shield, FileText, Lock, Eye, Database, UserCheck, Mail } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <div className="py-10 sm:py-16 px-4" style={{ backgroundColor: 'var(--tp-black)', minHeight: '80vh' }}>
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-2 text-white"
          style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}>
          PRIVACY & COOKIE POLICY
        </h1>
        <div className="w-20 h-1 mx-auto mb-8 sm:mb-12" style={{ backgroundColor: 'var(--tp-red)' }} />

        <div className="space-y-8">
          {/* Intro */}
          <section className="p-5 sm:p-6 rounded-lg border border-gray-800" style={{ backgroundColor: 'var(--tp-dark)' }}>
            <div className="flex items-start gap-3 mb-4">
              <Shield size={22} className="text-red-500 flex-shrink-0 mt-0.5" />
              <h2 className="text-xl font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>INFORMATIVA SULLA PRIVACY</h2>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              La presente informativa sulla privacy descrive come Tecniche Perfette ("noi", "nostro") raccoglie, utilizza e protegge le informazioni personali degli utenti del sito web www.tecnicheperfette.com. La privacy dei nostri utenti è di fondamentale importanza. Ci impegniamo a proteggere i dati personali in conformità con il Regolamento Generale sulla Protezione dei Dati (GDPR - Regolamento UE 2016/679) e la normativa italiana vigente.
            </p>
            <p className="text-gray-500 text-xs mt-3">
              Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT', { day: 'numeric', month: 'long', year: 'numeric' })}
            </p>
          </section>

          {/* Titolare del trattamento */}
          <section className="p-5 sm:p-6 rounded-lg border border-gray-800" style={{ backgroundColor: 'var(--tp-dark)' }}>
            <div className="flex items-start gap-3 mb-4">
              <UserCheck size={22} className="text-red-500 flex-shrink-0 mt-0.5" />
              <h2 className="text-xl font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>TITOLARE DEL TRATTAMENTO</h2>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Il titolare del trattamento dei dati personali è Tecniche Perfette, contattabile all'indirizzo email: <a href="mailto:info@tecnicheperfette.com" className="text-red-400 hover:text-red-300">info@tecnicheperfette.com</a> oppure al numero di telefono: 011 0448209.
            </p>
          </section>

          {/* Dati raccolti */}
          <section className="p-5 sm:p-6 rounded-lg border border-gray-800" style={{ backgroundColor: 'var(--tp-dark)' }}>
            <div className="flex items-start gap-3 mb-4">
              <Database size={22} className="text-red-500 flex-shrink-0 mt-0.5" />
              <h2 className="text-xl font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>DATI PERSONALI RACCOLTI</h2>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Raccogliamo i seguenti dati personali attraverso i form presenti sul sito:
            </p>
            <div className="space-y-3">
              <div className="p-3 bg-gray-800 rounded">
                <p className="text-white text-sm font-medium mb-1" style={{ fontFamily: 'Oswald, sans-serif' }}>Form di iscrizione al contest</p>
                <p className="text-gray-400 text-xs">Nome, cognome, email, numero di telefono, nickname/soprannome, città di partecipazione</p>
              </div>
              <div className="p-3 bg-gray-800 rounded">
                <p className="text-white text-sm font-medium mb-1" style={{ fontFamily: 'Oswald, sans-serif' }}>Form di contatto</p>
                <p className="text-gray-400 text-xs">Nome, email, oggetto del messaggio, testo del messaggio, eventuali file allegati</p>
              </div>
              <div className="p-3 bg-gray-800 rounded">
                <p className="text-white text-sm font-medium mb-1" style={{ fontFamily: 'Oswald, sans-serif' }}>Creazione profilo / biografia</p>
                <p className="text-gray-400 text-xs">Nome, nickname, ruolo, biografia, foto profilo, link ai profili social (Instagram, TikTok)</p>
              </div>
            </div>
          </section>

          {/* Finalità */}
          <section className="p-5 sm:p-6 rounded-lg border border-gray-800" style={{ backgroundColor: 'var(--tp-dark)' }}>
            <div className="flex items-start gap-3 mb-4">
              <Eye size={22} className="text-red-500 flex-shrink-0 mt-0.5" />
              <h2 className="text-xl font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>FINALITÀ DEL TRATTAMENTO</h2>
            </div>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li className="flex items-start gap-2"><span className="text-red-500 mt-1">•</span>Gestione delle iscrizioni al torneo Tecniche Perfette</li>
              <li className="flex items-start gap-2"><span className="text-red-500 mt-1">•</span>Risposta alle richieste di contatto e informazioni</li>
              <li className="flex items-start gap-2"><span className="text-red-500 mt-1">•</span>Pubblicazione dei profili degli artisti nella sezione Biografie</li>
              <li className="flex items-start gap-2"><span className="text-red-500 mt-1">•</span>Gestione degli ordini nel negozio online (merchandising)</li>
              <li className="flex items-start gap-2"><span className="text-red-500 mt-1">•</span>Invio di comunicazioni relative agli eventi (solo con consenso esplicito)</li>
              <li className="flex items-start gap-2"><span className="text-red-500 mt-1">•</span>Miglioramento del sito web e dell'esperienza utente</li>
            </ul>
          </section>

          {/* Cookie Policy */}
          <section className="p-5 sm:p-6 rounded-lg border border-gray-800" style={{ backgroundColor: 'var(--tp-dark)' }}>
            <div className="flex items-start gap-3 mb-4">
              <FileText size={22} className="text-red-500 flex-shrink-0 mt-0.5" />
              <h2 className="text-xl font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>COOKIE POLICY</h2>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-4">
              Il nostro sito utilizza i seguenti tipi di cookie:
            </p>
            <div className="space-y-3">
              <div className="p-3 bg-gray-800 rounded">
                <p className="text-white text-sm font-medium mb-1" style={{ fontFamily: 'Oswald, sans-serif' }}>Cookie necessari (sempre attivi)</p>
                <p className="text-gray-400 text-xs">Essenziali per il funzionamento del sito. Includono cookie di sessione e preferenze di consenso. Non possono essere disattivati.</p>
              </div>
              <div className="p-3 bg-gray-800 rounded">
                <p className="text-white text-sm font-medium mb-1" style={{ fontFamily: 'Oswald, sans-serif' }}>Cookie analitici (opzionali)</p>
                <p className="text-gray-400 text-xs">Ci aiutano a capire come gli utenti interagiscono con il sito, raccogliendo informazioni anonime sulle pagine visitate e le azioni compiute.</p>
              </div>
              <div className="p-3 bg-gray-800 rounded">
                <p className="text-white text-sm font-medium mb-1" style={{ fontFamily: 'Oswald, sans-serif' }}>Cookie di marketing (opzionali)</p>
                <p className="text-gray-400 text-xs">Utilizzati per mostrare contenuti e annunci pertinenti ai tuoi interessi, anche su piattaforme di terze parti.</p>
              </div>
            </div>
            <p className="text-gray-400 text-sm mt-4">
              Puoi modificare le tue preferenze sui cookie in qualsiasi momento cliccando su "Impostazioni Cookie" nel banner o eliminando i cookie dal tuo browser.
            </p>
          </section>

          {/* Diritti */}
          <section className="p-5 sm:p-6 rounded-lg border border-gray-800" style={{ backgroundColor: 'var(--tp-dark)' }}>
            <div className="flex items-start gap-3 mb-4">
              <Lock size={22} className="text-red-500 flex-shrink-0 mt-0.5" />
              <h2 className="text-xl font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>I TUOI DIRITTI</h2>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-3">
              In conformità con il GDPR, hai i seguenti diritti:
            </p>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li className="flex items-start gap-2"><span className="text-red-500 mt-1">•</span><strong className="text-gray-300">Diritto di accesso:</strong> richiedere quali dati personali conserviamo su di te</li>
              <li className="flex items-start gap-2"><span className="text-red-500 mt-1">•</span><strong className="text-gray-300">Diritto di rettifica:</strong> correggere dati inesatti o incompleti</li>
              <li className="flex items-start gap-2"><span className="text-red-500 mt-1">•</span><strong className="text-gray-300">Diritto alla cancellazione:</strong> richiedere l'eliminazione dei tuoi dati</li>
              <li className="flex items-start gap-2"><span className="text-red-500 mt-1">•</span><strong className="text-gray-300">Diritto alla portabilità:</strong> ricevere i tuoi dati in un formato strutturato</li>
              <li className="flex items-start gap-2"><span className="text-red-500 mt-1">•</span><strong className="text-gray-300">Diritto di opposizione:</strong> opporti al trattamento dei tuoi dati</li>
              <li className="flex items-start gap-2"><span className="text-red-500 mt-1">•</span><strong className="text-gray-300">Diritto di revocare il consenso:</strong> in qualsiasi momento, senza pregiudizio</li>
            </ul>
          </section>

          {/* Conservazione */}
          <section className="p-5 sm:p-6 rounded-lg border border-gray-800" style={{ backgroundColor: 'var(--tp-dark)' }}>
            <div className="flex items-start gap-3 mb-4">
              <Database size={22} className="text-red-500 flex-shrink-0 mt-0.5" />
              <h2 className="text-xl font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>CONSERVAZIONE DEI DATI</h2>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              I dati personali saranno conservati per il tempo strettamente necessario al raggiungimento delle finalità per cui sono stati raccolti. I dati relativi alle iscrizioni al contest saranno conservati per la durata dell'edizione corrente e per un periodo di 12 mesi successivi. I dati di contatto saranno conservati per il tempo necessario a rispondere alla richiesta. I profili pubblici nella sezione Biografie rimarranno attivi fino a richiesta di cancellazione da parte dell'utente.
            </p>
          </section>

          {/* Contatti */}
          <section className="p-5 sm:p-6 rounded-lg border border-gray-800" style={{ backgroundColor: 'var(--tp-dark)' }}>
            <div className="flex items-start gap-3 mb-4">
              <Mail size={22} className="text-red-500 flex-shrink-0 mt-0.5" />
              <h2 className="text-xl font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif' }}>CONTATTI PER LA PRIVACY</h2>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Per qualsiasi domanda relativa alla presente informativa o per esercitare i tuoi diritti, puoi contattarci a:
            </p>
            <div className="mt-3 p-3 bg-gray-800 rounded">
              <p className="text-white text-sm">Email: <a href="mailto:info@tecnicheperfette.com" className="text-red-400 hover:text-red-300">info@tecnicheperfette.com</a></p>
              <p className="text-white text-sm mt-1">Telefono: 011 0448209</p>
              <p className="text-white text-sm mt-1">Orari: DALLE 9 ALLE 18</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
